<template>
  <!--
    Selector de la sede de trabajo del encabezado. Solo se usa para los roles
    que pueden cambiarla (lo decide el backend); para el resto App.vue muestra
    la sede como texto, sin ningún control.

    Dos formas, misma lista:
      - normal:   el texto de la sede con una flecha (tablet y escritorio);
      - compacto: un botón con el ícono de sede (celular, donde el texto del
                  encabezado no entra).
  -->
  <v-menu offset-y left nudge-bottom="6" min-width="288" content-class="menu-sede">
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="compacto"
        icon
        dark
        :loading="cargando"
        aria-label="Cambiar la sede de trabajo"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="20" color="#EE680B">mdi-map-marker-outline</v-icon>
      </v-btn>
      <button
        v-else
        type="button"
        class="app-header__user-sede app-header__user-sede--elegible"
        :disabled="cargando"
        aria-label="Cambiar la sede de trabajo"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="12" color="#EE680B">mdi-map-marker-outline</v-icon>
        {{ nombreSede }}
        <v-icon size="14" color="rgba(255, 255, 255, 0.85)">
          {{ cargando ? 'mdi-loading mdi-spin' : 'mdi-chevron-down' }}
        </v-icon>
      </button>
    </template>

    <v-card class="menu-sede__panel" elevation="0">
      <div class="menu-sede__encabezado">
        <v-icon size="16" color="#EE680B">mdi-domain</v-icon>
        <span>Sede de trabajo</span>
      </div>
      <v-list class="menu-sede__lista py-1" role="listbox">
        <v-list-item
          v-for="sede in sedes"
          :key="sede.id_sede"
          :class="['menu-sede__item', { 'menu-sede__item--activa': sede.id_sede === idSede }]"
          role="option"
          :aria-selected="sede.id_sede === idSede ? 'true' : 'false'"
          :ripple="sede.id_sede !== idSede"
          @click="sede.id_sede !== idSede && $emit('elegir', sede)"
        >
          <v-list-item-content>
            <v-list-item-title class="menu-sede__nombre">{{ comoTitulo(sede.nombre) }}</v-list-item-title>
            <v-list-item-subtitle v-if="sede.id_sede === idSede" class="menu-sede__actual">
              Sede actual
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="sede.id_sede === idSede" class="my-0">
            <v-icon size="20" color="#EE680B">mdi-check-circle</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'MenuSedeActiva',

  props: {
    /** [{ id_sede, nombre }] */
    sedes: { type: Array, default: () => [] },
    /** Sede de trabajo actual. */
    idSede: { type: Number, default: null },
    /** Texto de la sede actual (el de la sesión). */
    nombreSede: { type: String, default: '' },
    /** Mientras se cambia de sede. */
    cargando: { type: Boolean, default: false },
    /** Botón con ícono en lugar del texto (celular). */
    compacto: { type: Boolean, default: false },
  },

  methods: {
    /** Los nombres vienen en mayúsculas: "SEDE CENTRAL" → "Sede Central". */
    comoTitulo(texto) {
      return String(texto || '')
        .toLowerCase()
        .replace(/(^|\s)(\S)/g, (_, espacio, letra) => espacio + letra.toUpperCase());
    },
  },
};
</script>

<style>
/* El contenido del v-menu se monta fuera del componente: estilos sin scoped. */
.menu-sede {
  border-radius: 10px !important;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 35, 71, 0.22), 0 2px 6px rgba(0, 35, 71, 0.12) !important;
}

.menu-sede .menu-sede__encabezado {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #002347;
  color: rgba(255, 255, 255, 0.92);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.menu-sede .menu-sede__lista {
  padding: 6px 0 !important;
}

.menu-sede .menu-sede__item {
  min-height: 48px;
  padding: 0 16px;
  border-left: 3px solid transparent;
  transition: background-color 0.15s ease;
}

.menu-sede .menu-sede__item:not(.menu-sede__item--activa):hover {
  background: rgba(0, 35, 71, 0.06);
}

.menu-sede .menu-sede__nombre {
  font-size: 14px;
  font-weight: 500;
  color: #1f2d3d;
}

.menu-sede .menu-sede__item--activa {
  border-left-color: #ee680b;
  background: rgba(238, 104, 11, 0.07);
  cursor: default;
}

.menu-sede .menu-sede__item--activa .menu-sede__nombre {
  color: #002347;
  font-weight: 600;
}

.menu-sede .menu-sede__actual {
  font-size: 11px;
  color: #ee680b !important;
}

@media (prefers-reduced-motion: reduce) {
  .menu-sede .menu-sede__item {
    transition: none;
  }
}
</style>
